const TransactionState = {
  transactions: {data: []}
};

export default TransactionState;
